module.exports = __webpack_public_path__ + "static/img/mariella.fdbaf70.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mariella.png
// module id = 124
// module chunks = 1